exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.basic.buttons.transaction-history--btn-group {\n  margin-left: 0.4rem;\n  margin-bottom: 1.5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/transactionhistory/index.less
// module id = 2942
// module chunks = 0